import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';

import { RunComponent } from './component/run/run.component';
import { RunsComponent } from './component/runs/runs.component';

export const RunRoutes: Routes = [
    {
        canActivate: [AuthService],
        component: RunsComponent,
        path: 'runs',
    },
    {
        canActivate: [AuthService],
        component: RunComponent,
        path: 'runs/:runId',
    },
];
